export default [
  {
    path: 'M301.226667 42.666667L512 207.914667 208.298667 384 0 227.370667 301.226667 42.666667zM0 583.296L208.298667 426.666667 512 602.752 301.226667 768 0 583.296z m512 19.498667L815.701333 426.666667 1024 583.296 722.773333 768 512 602.794667zM512 640l209.152 164.693333L810.666667 749.226667v62.165333L512 981.333333l-298.666667-169.941333V749.226667l89.514667 55.466666L512 640z m512-412.629333L722.773333 42.666667 512 207.914667 815.701333 384 1024 227.370667z',
    fill: '#0F82E2',
  },
]
